var lieux = [
  {
    code: "ST1",
    titre: "Studio Tonique Pilates",
    description: "Un studio où les clients peuvent trouver un confort à travers des entraînements physique à la mesure de leurs besoins et capacités.",
    adresse: "257 Boulevard Ste-Rose local 010, Laval",
    adresse1: "257 Boulevard Ste-Rose",
    adresse2: "local 010",
    ville: "Laval",
    codePostal: "H7L2X1",
    secteur: "Laval - Sainte-Rose",
    horaire: "Lundi de 17h30 à 19h30",
    ambassadeur: "", // Vide
    web: "http://www.studiotoniquepilates.com",
    latitude: 45.6124282,
    longitude: -73.7895729,
    private: false,
  },
  {
    code: "FA1",
    titre: "La Fabrique Végé",
    description: "Boutique de prêt-à-manger écologique à Sainte-Adèle. Menu 100% végane et zéro déchet, repas, wraps, collations et desserts",
    adresse: "422 ch. Pierre-Péladeau, Sainte-Adèle, J8B 1Z3",
    adresse1: "422 ch. Pierre-Péladeau",
    adresse2: "",
    ville: "Sainte-Adèle",
    codePostal: "J8B 1Z4",
    secteur: "Laurentides",
    horaire: "Lundi de 10h à 17h",
    ambassadeur: "", // Vide
    web: "https://fabriquevege.com/",
    latitude: 45.952267, 
    longitude: -74.135113,
    private: false,
  },
  {
    code: "MB1",
    titre: "Megavrac Beaubien",
    description: "Épicerie écologique zéro déchet, à Montréal, qui propose plus de 1000 produits alimentaires et ménagers vendus en vrac et sans emballage.",
    adresse: "2109 Rue Beaubien E, Montréal, QC H2G 1M5",
    adresse1: "2109 Rue Beaubien E",
    adresse2: "",
    ville: "Montréal",
    codePostal: "H2G 1M5",
    secteur: "Beaubien",
    horaire: "Lundi de 15h à 19h",
    ambassadeur: "", // Vide
    web: "https://megavrac.com/",
    latitude: 45.545895, 
    longitude: -73.59431, 
    private: false,
  },
  {
    code: "MR1",
    titre: "Megavrac Rosemont",
    description: "Épicerie écologique zéro déchet, à Montréal, qui propose plus de 1000 produits alimentaires et ménagers vendus en vrac et sans emballage.",
    adresse: "3022 Rue Masson, Montréal, H1Y 1W1",
    adresse1: "3022 Rue Masson",
    adresse2: "",
    ville: "Montréal",
    codePostal: "H1X 1X6",
    secteur: "Rosemont",
    horaire: "Lundi de 15h à 20h",
    ambassadeur: "", // Vide
    web: "https://megavrac.com/",
    latitude: 45.549237, 
    longitude: -73.574196,
    private: false,
  },
  {
    code: "MV1",
    titre: "Megavrac Villeray",
    description: "Épicerie écologique zéro déchet, à Montréal, qui propose plus de 1000 produits alimentaires et ménagers vendus en vrac et sans emballage.",
    adresse: "421 Rue Villeray E, Montréal, QC H2R 1H2",
    adresse1: "421 rue Villeray Est",
    adresse2: "",
    ville: "Montréal",
    codePostal: "H2R 1H2",
    secteur: "Villeray",
    horaire: "Lundi de 15h à 20h",
    ambassadeur: "", // Vide
    web: "https://megavrac.com/",
    latitude: 45.541140, 
    longitude: -73.623334,
    private: false,
  },
    {
    code: "MP1",
    titre: "Megavrac Plateau",
    description: "Épicerie écologique zéro déchet, à Montréal, qui propose plus de 1000 produits alimentaires et ménagers vendus en vrac et sans emballage.",
    adresse: "1951 Avenue du Mont-Royal E, Montréal, QC H2H 1J5",
    adresse1: "1951 Avenue du Mont-Royal E",
    adresse2: "",
    ville: "Montréal",
    codePostal: "H2H 1J5",
    secteur: "Plateau",
    horaire: "Lundi de 15h à 20h",
    ambassadeur: "", // Vide
    web: "https://megavrac.com/",
    latitude: 45.534199,
    longitude: -73.573642,
    private: false,
  },
  {
    code: "MH1",
    titre: "Megavrac Hochelaga",
    description: "Épicerie écologique zéro déchet, à Montréal, qui propose plus de 1000 produits alimentaires et ménagers vendus en vrac et sans emballage.",
    adresse: "3562 Rue Ontario E, Montréal, QC H1W 1R5",
    adresse1: "3562 Rue Ontario E",
    adresse2: "",
    ville: "Montréal",
    codePostal: "H1W 1R5",
    secteur: "Hochelaga",
    horaire: "Lundi de 15h à 19h",
    ambassadeur: "", // Vide
    web: "https://megavrac.com/",
    latitude: 45.544759, 
    longitude: -73.545030,
    private: false,
  },
  {
    code: "MH1",
    titre: "Megavrac Laurier",
    description: "Épicerie écologique zéro déchet, à Montréal, qui propose plus de 1000 produits alimentaires et ménagers vendus en vrac et sans emballage.",
    adresse: "1397 Avenue Laurier Est, Montréal, QC H2J 3T3",
    adresse1: "1397 Avenue Laurier Est",
    adresse2: "",
    ville: "Montréal",
    codePostal: "H2J 3T3",
    secteur: "Laurier",
    horaire: "Lundi de 15h à 19h",
    ambassadeur: "", // Vide
    web: "https://megavrac.com/",
    latitude: 45.533884, 
    longitude: -73.583560,
    private: false,
  },
  {
    code: "RR1",
    titre: "La Réserve Naturelle Rosemont",
    description: "l’endroit où les gens du quartier aient envie d’aller prendre conseil et s’approvisionner de façon zéro déchet.",
    adresse: "5854 Rue St-Hubert, Montréal, QC H2S 2L7",
    adresse1: "5854 Rue St-Hubert",
    adresse2: "",
    ville: "Montréal",
    codePostal: "H2S 2L7",
    secteur: "Rosemont",
    horaire: "Lundi de 15h à 18h30",
    ambassadeur: "", // Vide
    web: "https://lareservenaturelle.com/fr/",
    latitude: 45.533453, 
    longitude: -73.597167,
    private: false,
  }
]; 